import {combineReducers, createStore} from "redux";
import appStoreReducer from "./app-store-reducer";

let reducers = combineReducers({
    appStore: appStoreReducer
});

let store = createStore(reducers);

export default store;